import UserHomeBase from './UserHomeBase';

const MasterHome = () => <UserHomeBase master />;

export default MasterHome;
